/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ToastContainer } from "react-toastify";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";
// import moment from "moment";
// import _ from "lodash";

import TopCard from "./TopCard";
import { helperFunction } from "../../../constant/helper";
import { dashboardActions } from "../../../redux/actions";
import Card from "../../../component/card/Card";
import AttendanceGraph from "./AttendanceGraph";
// import GoogleMapComponent from "../../../component/map/GoogleMapComponent";
import isEmpty from "../../../validation/isEmpty";
// import DonutGraph from "./DonutGraph";

// const initialMarker = [
//   {
//     id: 1,
//     name: "HEAD OFFICE BHANDUP",
//     position: {
//       lat: 19.160894477402863,
//       lng: 72.9429362754193
//     }
//   }
// ];

const HrDashboard = ({ loginType }) => {
  const dispatch = useDispatch();
  const [numberOfWorkers, setNumberOfWorkers] = useState(0);
  const [totalAwsFaceRegister, setTotalAwsFaceRegister] = useState(0);
  const [totalActiveRule, setTotalActiveRule] = useState(0);
  const [numberOfEmployee, setNumberOfEmployee] = useState(0);
  // const [markers, setMarkers] = useState(initialMarker);
  // const [combineData, setCombineData] = useState([]);

  const {
    numberOfUsers,
    // numberOfActiveUsers,
    numberOfRules,
    totalAwsUsers,
    dashboardError,
    // googleMapArray,
    numberOfLocations,
    dailyAttendanceLocationWiseGraph
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    setTimeout(() => {
      const empty = isEmpty(numberOfRules);
      if (!empty) {
        const activeRule = numberOfRules.map((rule) => {
          if (rule._id.activeNow) {
            return rule.count;
          }
        });
        setTotalActiveRule(activeRule);
      }
    }, 1000);
  }, [numberOfRules]);

  useEffect(() => {
    setTimeout(() => {
      const empty = isEmpty(totalAwsUsers);
      if (!empty) {
        const activeRule = totalAwsUsers.map((rule) => {
          if (rule._id.workerFaceRegistered) {
            return rule.count;
          }
        });
        setTotalAwsFaceRegister(activeRule);
      }
    }, 1000);
  }, [totalAwsUsers]);

  useEffect(() => {
    dispatch(dashboardActions.setDashboardLoading(true));
    dispatch(dashboardActions.clearDashboardErrors());
    dispatch(dashboardActions.clearDashboardResult());
    dispatch(dashboardActions.getDashboardData(loginType));
    // setTimeout(() => {
    //   const todaysDate = moment(new Date()).format("yyyy-MM-DD");
    //   dispatch(dashboardActions.googleMapData(todaysDate, loginType));
    //   // dispatch(userActions.getAllAwsUsers(loginType));
    // }, 1000);

    return () => {
      dispatch(dashboardActions.setDashboardLoading(false));
      dispatch(dashboardActions.clearDashboardErrors());
      dispatch(dashboardActions.clearDashboardResult());
      dispatch(dashboardActions.unmountDashboardData());
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!isEmpty(numberOfUsers)) {
        numberOfUsers.forEach((data) => {
          if (data._id === "Employee") {
            setNumberOfEmployee(data.count);
          }
          if (data._id === "Worker") {
            setNumberOfWorkers(data.count);
          }
        });
      }
    }, 2000);
  }, [numberOfUsers]);

  useEffect(() => {
    if (dashboardError) {
      helperFunction.toastHelper("error", dashboardError);
    }
  }, [dashboardError]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!isEmpty(googleMapArray)) {
  //       const data = [];
  //       googleMapArray.map((googleData, index) => {
  //         data.push({
  //           id: index + 1,
  //           name: googleData.name,
  //           position: {
  //             lat: googleData.locations[0],
  //             lng: googleData.locations[1]
  //           }
  //         });
  //       });

  //       setMarkers(data);
  //     }
  //   }, 2000);
  // }, [googleMapArray]);

  const skeletonEffect = (
    <Card isHeader={false}>
      <Skeleton height={85} />
    </Card>
  );

  const showTopBar = () => {
    if (numberOfUsers !== null) {
      return (
        <div className="row">
          <div className="col-xl-3 col-md-3 col-lg-3">
            <TopCard
              title="Employee / Workers"
              content={numberOfEmployee + " / " + numberOfWorkers}
              link="/hr/user/all-users"
              icon="mdi mdi-account-multiple widget-icon"
              data_for="usersTip"
              toolTipTitle={`Click to See All ${loginType}`}
            />
          </div>
          <div className="col-xl-3 col-md-3 col-lg-3">
            <TopCard
              title="Locations"
              content={numberOfLocations.length}
              link="/hr/location/all-locations"
              icon="mdi mdi-map-marker-radius widget-icon"
              data_for="locationTip"
              toolTipTitle="Click to See All Locations"
            />
          </div>

          <div className="col-xl-3 col-md-3 col-lg-3">
            <TopCard
              title="Rules"
              content={totalActiveRule}
              link="/hr/rules/all-rules"
              icon="mdi mdi-android-studio widget-icon"
              data_for="rulesTip"
              toolTipTitle="Click to See All Rules"
            />
          </div>

          <div className="col-xl-3 col-md-3 col-lg-3">
            <TopCard
              title="Total Face Register"
              content={totalAwsFaceRegister}
              link="#"
              icon="mdi mdi-account-multiple widget-icon"
              data_for="awsUsersTip"
              toolTipTitle="Total Face Register To Aws"
            />
          </div>
        </div>
      );
    } else if (numberOfUsers === null) {
      return (
        <div className="row">
          <div className="col-xl-3 col-md-3 col-lg-3">
            {skeletonEffect}
          </div>
          <div className="col-xl-3 col-md-3 col-lg-3">
            {skeletonEffect}
          </div>
          <div className="col-xl-3 col-md-3 col-lg-3">
            {skeletonEffect}
          </div>
          <div className="col-xl-3 col-md-3 col-lg-3">
            {skeletonEffect}
          </div>
        </div>
      );
    }
  };

  const showGraph = () => {
    if (dailyAttendanceLocationWiseGraph === null) {
      return (
        <Card>
          <Skeleton height={410} />
        </Card>
      );
    } else if (dailyAttendanceLocationWiseGraph !== null) {
      return (
        <AttendanceGraph
          dailyAttendanceLocationWiseGraph={
            dailyAttendanceLocationWiseGraph
          }
        />
      );
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            {showTopBar()}
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            {showGraph()}
          </div>
        </div>
        {/* <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <GoogleMapComponent markers={markers} />
          </div>
        </div> */}
      </div>
    </>
  );
};

HrDashboard.propTypes = {
  loginType: PropTypes.string.isRequired
};

export default HrDashboard;
